import { NS_CONFIGURATION, PERSONAL } from 'redux/constants';
import { action, createType, SYNC, ASYNC } from 'redux-create-type';

export const {
  INIT,
  SAVE,
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_ABOUT_ME,
  INVALIDATE,
  RESET_CHANGES,
  SET_AVATAR,
  SET_RECEIVE_EMAIL,
  SET_LANGUAGE,
  SET_COMPANY,
  SET_PHONE,
} = createType(NS_CONFIGURATION, PERSONAL)({
    INIT: ASYNC,
    SAVE: ASYNC,
    SET_FIRST_NAME: SYNC,
    SET_LAST_NAME: SYNC,
    SET_ABOUT_ME: SYNC,
    INVALIDATE: SYNC,
    RESET_CHANGES: ASYNC,
    SET_AVATAR: SYNC,
    SET_RECEIVE_EMAIL: SYNC,
    SET_LANGUAGE: SYNC,
    SET_COMPANY: SYNC,
    SET_PHONE: SYNC,
  });

export const init = {
  begin: () => action(INIT.BEGIN),
  end: ({
    userSettings,
    origSettings,
    afterRegistration
       }) => action(INIT.END, {
        userSettings,
        origSettings,
        afterRegistration
    }),
};
export const save = {
  begin: () => action(SAVE.BEGIN),
  end: ({
    origSettings,
    }) => action(SAVE.END, {
      origSettings,
    }),
};
export const setFirstName = value => action(SET_FIRST_NAME, { value });
export const setLastName = value => action(SET_LAST_NAME, { value });
export const setAboutMe = value => action(SET_ABOUT_ME, { value });
export const selectLanguage = value => action(SET_LANGUAGE, { value });
export const setCompany = value => action(SET_COMPANY, { value });
export const setPhone = value => action(SET_PHONE, { value });

export const invalidate = ({ changes }) => action(INVALIDATE, { changes });
export const resetChanges = {
  begin: () => action(RESET_CHANGES.BEGIN),
  end: ({
    userSettings,
    }) => action(RESET_CHANGES.END, {
      userSettings,
    }),
};
export const setAvatar = avatar => action(SET_AVATAR, { avatar });
export const setReceiveEmail = ({ item, value }) => action(SET_RECEIVE_EMAIL, { item, value });


// WEBPACK FOOTER //
// ../redux/store/configuration/personal/actions.js